import {Component, Input, OnInit} from '@angular/core';
import {LogisticDay} from '../../../../../data/logistic-day';
import {CdkDragDrop, moveItemInArray, transferArrayItem} from '@angular/cdk/drag-drop';
import {LogisticRoutesService} from '../../../../../data/logistic-routes.service';

@Component({
  selector: 'app-logistic-planning-day',
  templateUrl: './logistic-planning-day.component.html',
  styleUrls: ['./logistic-planning-day.component.scss']
})
export class LogisticPlanningDayComponent implements OnInit {

  @Input()
  day: LogisticDay;

  dndActive = false;

  constructor(
    protected logisticRoutesService: LogisticRoutesService
  ) {
  }

  ngOnInit(): void {
  }

  dndStart() {
    this.logisticRoutesService.suggestionDndActive = true;
  }

  dndEnd() {
    this.logisticRoutesService.suggestionDndActive = false;
  }

  suggestionDrop(event: CdkDragDrop<any>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );
    }
  }
}
